import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Floating Back Button for Mobile
 * Shows on all mobile screens except Base
 */
const MobileBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Don't show on Base screen, Photo screen, or pages with AuthHeader
  const excludedPaths = [
    "/",
    "/today",
    "/photo",
    "/rental-bookings",
    "/settings",
    "/payments",
    "/locks",
    "/customer-locks",
    "/bookings",
    "/contact-pad",
    "/booking-wizard"
  ];
  
  if (excludedPaths.some(path => location.pathname.startsWith(path))) {
    return null;
  }

  // Use top-left position for Messages screen only
  const isMessagesScreen = location.pathname === "/messages";
  const buttonStyle = isMessagesScreen
    ? styles.floatingBackButtonTopLeft
    : styles.floatingBackButton;

  return (
    <TouchableOpacity dataSet={{ hover: "lift" }} style={buttonStyle} onPress={() => navigate(-1)}>
      <Text style={styles.floatingBackButtonText}>←</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  floatingBackButton: {
    position: 'absolute',
    bottom: 20,
    left: 20,
    width: 50,
    height: 50,
    backgroundColor: 'rgba(0, 122, 255, 0.5)',
    borderRadius: 25,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    boxShadow: "0 2px 6px rgba(15, 26, 25, 0.08), 0 16px 40px rgba(15, 26, 25, 0.12)",
    elevation: 10,
  },
  floatingBackButtonTopLeft: {
    position: 'absolute',
    top: 20,
    left: 20,
    width: 50,
    height: 50,
    backgroundColor: 'rgba(0, 122, 255, 0.5)',
    borderRadius: 25,
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
    boxShadow: "0 2px 6px rgba(15, 26, 25, 0.08), 0 16px 40px rgba(15, 26, 25, 0.12)",
    elevation: 10,
  },
  floatingBackButtonText: {
    color: '#FFFFFF',
    fontSize: 28,
    fontWeight: 'bold',
    lineHeight: 28,
  },
});

export default MobileBackButton;
